export default "__VITE_ASSET__DZM1kHRY__"